// @ts-nocheck
export const localeCodes =  [
  "nl",
  "nl-be",
  "fr-be",
  "fr",
  "de",
  "de-at",
  "en"
]
export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46json_49fd24de",
      load: () => import("#nuxt-i18n/49fd24de" /* webpackChunkName: "locale_nl_46json_49fd24de" */),
      cache: true
    },
    {
      key: "locale_nl_46json_eea2b785",
      load: () => import("#nuxt-i18n/eea2b785" /* webpackChunkName: "locale_nl_46json_eea2b785" */),
      cache: true
    },
    {
      key: "locale_nl_46json_8a163aa6",
      load: () => import("#nuxt-i18n/8a163aa6" /* webpackChunkName: "locale_nl_46json_8a163aa6" */),
      cache: true
    }
  ],
  "nl-be": [
    {
      key: "locale_nl_46json_49fd24de",
      load: () => import("#nuxt-i18n/49fd24de" /* webpackChunkName: "locale_nl_46json_49fd24de" */),
      cache: true
    },
    {
      key: "locale_nl_46json_eea2b785",
      load: () => import("#nuxt-i18n/eea2b785" /* webpackChunkName: "locale_nl_46json_eea2b785" */),
      cache: true
    },
    {
      key: "locale_nl_46json_8a163aa6",
      load: () => import("#nuxt-i18n/8a163aa6" /* webpackChunkName: "locale_nl_46json_8a163aa6" */),
      cache: true
    }
  ],
  "fr-be": [
    {
      key: "locale_fr_46json_805ec6ba",
      load: () => import("#nuxt-i18n/805ec6ba" /* webpackChunkName: "locale_fr_46json_805ec6ba" */),
      cache: true
    },
    {
      key: "locale_fr_46json_de506d8a",
      load: () => import("#nuxt-i18n/de506d8a" /* webpackChunkName: "locale_fr_46json_de506d8a" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6a15aa63",
      load: () => import("#nuxt-i18n/6a15aa63" /* webpackChunkName: "locale_fr_46json_6a15aa63" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_805ec6ba",
      load: () => import("#nuxt-i18n/805ec6ba" /* webpackChunkName: "locale_fr_46json_805ec6ba" */),
      cache: true
    },
    {
      key: "locale_fr_46json_de506d8a",
      load: () => import("#nuxt-i18n/de506d8a" /* webpackChunkName: "locale_fr_46json_de506d8a" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6a15aa63",
      load: () => import("#nuxt-i18n/6a15aa63" /* webpackChunkName: "locale_fr_46json_6a15aa63" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_0314d2e6",
      load: () => import("#nuxt-i18n/0314d2e6" /* webpackChunkName: "locale_de_46json_0314d2e6" */),
      cache: true
    },
    {
      key: "locale_de_46json_a5d8148f",
      load: () => import("#nuxt-i18n/a5d8148f" /* webpackChunkName: "locale_de_46json_a5d8148f" */),
      cache: true
    },
    {
      key: "locale_de_46json_1def1b90",
      load: () => import("#nuxt-i18n/1def1b90" /* webpackChunkName: "locale_de_46json_1def1b90" */),
      cache: true
    }
  ],
  "de-at": [
    {
      key: "locale_de_46json_0314d2e6",
      load: () => import("#nuxt-i18n/0314d2e6" /* webpackChunkName: "locale_de_46json_0314d2e6" */),
      cache: true
    },
    {
      key: "locale_de_46json_a5d8148f",
      load: () => import("#nuxt-i18n/a5d8148f" /* webpackChunkName: "locale_de_46json_a5d8148f" */),
      cache: true
    },
    {
      key: "locale_de_46json_1def1b90",
      load: () => import("#nuxt-i18n/1def1b90" /* webpackChunkName: "locale_de_46json_1def1b90" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_64b31172",
      load: () => import("#nuxt-i18n/64b31172" /* webpackChunkName: "locale_en_46json_64b31172" */),
      cache: true
    },
    {
      key: "locale_en_46json_7c7e4823",
      load: () => import("#nuxt-i18n/7c7e4823" /* webpackChunkName: "locale_en_46json_7c7e4823" */),
      cache: true
    },
    {
      key: "locale_en_46json_06a29999",
      load: () => import("#nuxt-i18n/06a29999" /* webpackChunkName: "locale_en_46json_06a29999" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/e33c0eb8" /* webpackChunkName: "config_i18n_46config_46ts_e33c0eb8" */),
  () => import("#nuxt-i18n/a40eec4e" /* webpackChunkName: "config_i18n_46config_46ts_a40eec4e" */),
  () => import("#nuxt-i18n/c3ed05e8" /* webpackChunkName: "config_i18n_46config_46ts_c3ed05e8" */),
  () => import("#nuxt-i18n/82a8a38c" /* webpackChunkName: "config_i18n_46config_46ts_82a8a38c" */)
]
export const normalizedLocales = [
  {
    code: "nl",
    language: "nl-NL",
    storeCode: "nl_nl",
    domain: "https://giftcard.dille-kamille.nl",
    name: "Nederlands",
    flag: "🇳🇱",
    numberFormats: {
      currency: {
        style: "currency",
        currency: "EUR"
      }
    },
    datetimeFormats: {
      default: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      },
      short: {
        year: "numeric",
        month: "short",
        day: "2-digit"
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long"
      }
    }
  },
  {
    code: "nl-be",
    language: "nl-BE",
    storeCode: "nl_be",
    domain: "https://giftcard.dille-kamille.be/nl/",
    name: "Nederlands (BE)",
    flag: "🇧🇪",
    numberFormats: {
      currency: {
        style: "currency",
        currency: "EUR"
      }
    },
    datetimeFormats: {
      default: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      },
      short: {
        year: "numeric",
        month: "short",
        day: "2-digit"
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long"
      }
    }
  },
  {
    code: "fr-be",
    language: "fr-BE",
    storeCode: "fr_be",
    domain: "https://giftcard.dille-kamille.be/fr/",
    name: "Français (BE)",
    flag: "🇧🇪",
    numberFormats: {
      currency: {
        style: "currency",
        currency: "EUR"
      }
    },
    datetimeFormats: {
      default: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      },
      short: {
        year: "numeric",
        month: "short",
        day: "2-digit"
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long"
      }
    }
  },
  {
    code: "fr",
    language: "fr-FR",
    storeCode: "fr_fr",
    domain: "https://giftcard.dille-kamille.fr",
    name: "Français",
    flag: "🇫🇷",
    numberFormats: {
      currency: {
        style: "currency",
        currency: "EUR"
      }
    },
    datetimeFormats: {
      default: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      },
      short: {
        year: "numeric",
        month: "short",
        day: "2-digit"
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long"
      }
    }
  },
  {
    code: "de",
    language: "de-DE",
    storeCode: "de_de",
    domain: "https://giftcard.dille-kamille.de",
    name: "Deutsch",
    flag: "🇩🇪",
    numberFormats: {
      currency: {
        style: "currency",
        currency: "EUR"
      }
    },
    datetimeFormats: {
      default: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      },
      short: {
        year: "numeric",
        month: "short",
        day: "2-digit"
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long"
      }
    }
  },
  {
    code: "de-at",
    language: "de-AT",
    storeCode: "de_at",
    domain: "https://giftcard.dille-kamille.at",
    name: "Deutsch (AT)",
    flag: "🇦🇹",
    numberFormats: {
      currency: {
        style: "currency",
        currency: "EUR"
      }
    },
    datetimeFormats: {
      default: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      },
      short: {
        year: "numeric",
        month: "short",
        day: "2-digit"
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long"
      }
    }
  },
  {
    code: "en",
    language: "en-GB",
    storeCode: "en_en",
    domain: "https://giftcard.dille-kamille.com",
    name: "English",
    flag: "🇬🇧",
    numberFormats: {
      currency: {
        style: "currency",
        currency: "EUR"
      }
    },
    datetimeFormats: {
      default: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      },
      short: {
        year: "numeric",
        month: "short",
        day: "2-digit"
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long"
      }
    }
  }
]
/** client **/

/** client-end **/